import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import TrailActivityType from '../types/TrailActivityType';

const messages = defineMessages<TrailActivityType>({
  backpacking: { defaultMessage: 'Backpacking' },
  'bike-touring': { defaultMessage: 'Bike touring' },
  birding: { defaultMessage: 'Birding' },
  camping: { defaultMessage: 'Camping' },
  'cross-country-skiing': { defaultMessage: 'Cross-country skiing' },
  fishing: { defaultMessage: 'Fishing' },
  hiking: { defaultMessage: 'Hiking' },
  'horseback-riding': { defaultMessage: 'Horseback riding' },
  'mountain-biking': { defaultMessage: 'Mountain biking' },
  'off-road-driving': { defaultMessage: 'Off-road driving' },
  'paddle-sports': { defaultMessage: 'Paddle sports' },
  'road-biking': { defaultMessage: 'Road biking' },
  'rock-climbing': { defaultMessage: 'Rock climbing' },
  'scenic-driving': { defaultMessage: 'Scenic driving' },
  skiing: { defaultMessage: 'Skiing' },
  snowshoeing: { defaultMessage: 'Snowshoeing' },
  'trail-running': { defaultMessage: 'Running' },
  'via-ferrata': { defaultMessage: 'Via ferrata' },
  walking: { defaultMessage: 'Walking' }
});

export default function getTrailActivityTypeLabel(intl: IntlShape, activityType: TrailActivityType): string {
  const message = messages[activityType];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown activity type: ${activityType}`));
  return '';
}
